<template>
  <div class="checkbox">
    <input
      type="checkbox"
      :value="value"
      @change="onChange"
      v-model="currentValue"
      :name="name"
      :id="id || name"
      class="form-control"
      :aria-checked="currentValue"
      :style="
        size ? `flex: 0 0 ${size}px;width:${size}px;height:${size}px` : ''
      "
    />
    <slot />
  </div>
</template>
<script>
export default {
  $_veeValidate: {
    // fetch the current value from the innerValue defined in the component data.
    value() {
      return this.currentValue;
    },
    rejectsFalse: true
  },
  name: "UiCheckbox",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null,
      required: true
    },
    size: {
      type: [Number, String],
      validate: val => parseInt(val),
      default: 16
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentValue: null
    };
  },
  methods: {
    onChange() {
      this.$emit("input", Boolean(this.currentValue));
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.currentValue = newVal;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.checkbox {
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  align-items: flex-start;
}

input[type="checkbox"] {
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  border: 1px var(--fe-base-inverted) solid;
  background: var(--fe-base);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s 0s ease-in-out;
  cursor: pointer;

  &:after {
    font-size: 12px;
    font-weight: bold;
    content: "✔︎";
    visibility: hidden;

    color: var(--fe-base);
  }

  &[aria-checked] {
    background: 1px var(--fe-base-inverted) solid;
    background: var(--fe-base-inverted);
    color: var(--fe-base);

    &:after {
      visibility: visible;
    }
  }
}
</style>
